import { render, staticRenderFns } from "./ZahlungseingangZuweisenModal.vue?vue&type=template&id=10f9b6fc&"
import script from "./ZahlungseingangZuweisenModal.vue?vue&type=script&lang=js&"
export * from "./ZahlungseingangZuweisenModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports